import cookies from 'browser-cookies';
import config from '@/services/config.api';
import { axiosWithHeaders } from '@innovyze/lib_get_service';
import { FetchConfig } from '@/types/chat';

const apiClient = axiosWithHeaders({
  service: 'w3fAgentServer',
  config,
  axiosCreateOpts: {
    headers: { 'Content-Type': 'application/json' },
    timeout: 30000,
  },
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.error('Unauthorized access');
    }
    return Promise.reject(error);
  },
);

export const buildFetchConfig = (
  additionalHeaders?: Record<string, string>,
): FetchConfig => {
  const baseURL = apiClient.defaults.baseURL || '';

  const token = cookies.get('auth0.user.token');
  const tenantId = sessionStorage.getItem('tenantId');

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...additionalHeaders,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (tenantId) {
    headers['X-Tenant-Id'] = tenantId;
  }

  return {
    baseURL,
    headers,
  };
};
